import axios from 'axios';

export default class NewsletterSubscriptionService {
    constructor(){}

    public async subscribe(email: string) : Promise<boolean> {
        let api = axios.create({
            baseURL: ''
        });

        const data : any = await api.post('/Newsletter/SubscribeToNewsletter', {
            email: email
        });

        return true;
    }
}